<air-form
  #formComponent
  [controls]="form"
  [showMandatory]="true"
  [showInvalidToast]="true"
  [disabled]="formDisabled"
  [triggerValidation]="!!content.triggerValidation"
  [class.loading]="loading"
  (submitted)="submitValues($event)"
  [userEventSource]="userEventSource"
>
  <button
    type="button"
    (click)="submit($event)"
    class="button form__button button--full-width button--cta"
    [airButtonLoading]="isSubmitting"
    [disabled]="isDisabled"
  >
    <span>{{ (isDisabled ? "general.label.no_changes" : "general.label.save_changes") | translate }}</span>
  </button>
</air-form>
<p class="form__mandatory-label">{{ "general.label.mandatory_fields" | translate }}</p>
